// Utility function to get permissions for a specific feature
export const getFeaturePermissions = (featureName) => {
  const permissions = JSON.parse(localStorage.getItem("permissions"));
  const features = JSON.parse(localStorage.getItem("features"));

  if (!permissions || !Array.isArray(permissions)) return null;

  const feature = permissions.find(
    (perm) =>
      perm.feature_id &&
      features &&
      features[featureName] === perm.feature_id
  );

  return feature || null;
};
